
import { cn } from '@/lib/utils';

/**
 * Initials chip. The server sends both the initials and a stable per-agent
 * colour, so the same agent always renders the same swatch as the old admin.
 */
export function Avatar({
  initials,
  color,
  size = 'md',
  className,
  title,
}: {
  initials: string;
  color?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
  title?: string;
}) {
  const sizes = {
    xs: 'size-5 text-[9px]',
    sm: 'size-6 text-[10px]',
    md: 'size-7 text-[11px]',
    lg: 'size-9 text-sm',
  };

  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full font-semibold uppercase text-white',
        sizes[size],
        !color && 'bg-primary',
        className,
      )}
      style={color ? { backgroundColor: color } : undefined}
      title={title}
      aria-hidden={!title}
    >
      {initials || '—'}
    </span>
  );
}

export function AgentCell({
  agent,
  fallback = 'Unassigned',
  size = 'sm',
  className,
}: {
  agent: { name: string; initials: string; color: string } | null | undefined;
  fallback?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}) {
  if (!agent) {
    return <span className={cn('text-xs text-ink-4', className)}>{fallback}</span>;
  }
  return (
    <span className={cn('flex min-w-0 items-center gap-1.5', className)}>
      <Avatar initials={agent.initials} color={agent.color} size={size} title={agent.name} />
      <span className="truncate text-[13px] text-ink-2">{agent.name}</span>
    </span>
  );
}
